import styled from "@emotion/styled";
import { TextareaAutosize, IconButton } from "@mui/material";

type Props = {
  ifbackgoundcolor?: string;
  ifSecondFontColor?: string;
  ifbordercolor?: string;
  iffontcolor?: string;
  brandColor?: string;
  ifMobile?: boolean;
  ifiOSMobile?: boolean;
};

export const Container = styled.div`
  display: block;
  width: 100%;
  flex-direction: column;
  padding: 10px 0;
  margin-top: auto;
`;

export const StatusContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
`;

export const StatusText = styled.div<Props>`
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  ${({ ifSecondFontColor }) =>
    ifSecondFontColor ? `color: ${ifSecondFontColor};` : `color: #aaa;`};
  font-size: 12px;
  font-weight: 600;
`;

export const InputForm = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  padding: 0px;
`;

export const InputOptions = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
`;

export const Input = styled(TextareaAutosize)<Props>`
  padding: 5px 10px;
  height: 32px;
  font-size: 14px;
  line-height: 20px;
  border-radius: 8px;
  flex-grow: 1;
  width: auto;
  box-sizing: border-box;
  resize: none;
  font-family: sans-serif;
  margin-left: 8px;
  ${({ ifiOSMobile }) =>
    ifiOSMobile &&
    `&:focus {
      font-size: 16px;
    }`}
  ${({ ifbackgoundcolor }) =>
    ifbackgoundcolor && `background: ${ifbackgoundcolor};`}
  ${({ iffontcolor }) => iffontcolor && `color: ${iffontcolor};`}
  ${({ ifbordercolor }) =>
    ifbordercolor
      ? `border: 1px solid ${ifbordercolor};`
      : `border: 1px solid #aaa;`}
`;

export const ActionButton = styled.label<Props>`
  padding: 3px;
  padding-bottom: 2px;
  margin: 0 5px;
  cursor: pointer;
  svg {
    width: 19px;
    height: auto;
    ${({ ifSecondFontColor }) =>
      ifSecondFontColor ? `color: ${ifSecondFontColor};` : `color: #aaa;`}
  }
`;

export const EmojiSelector = styled.div`
  position: absolute;
  bottom: 45px;
  right: 10px;
`;

export const PresetGroup = styled.div`
  display: flex;
  flex-direction: row;
  padding: 3px 5px;
  justify-content: center;
`;

export const PresetText = styled.div`
  margin: 3px;
  padding: 7px 12px;
  border: 1px solid #aaa;
  color: #aaa;
  border-radius: 20px;
  cursor: pointer;
`;

export const SendBtnIcon = styled(IconButton)<Props>`
  color: #1f8feb;
  font-size: 21px;
  padding: 4px;
  &:hover {
    background: none;
    box-shadow: none;
  }
`;
